export default __webpack_public_path__ + "static/media/grafema_ummi_21.07fc822a.mp4";